import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private readonly httpWithoutInterceptor: HttpClient;

  constructor(private httpBackend: HttpBackend) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }

  imageUrlToBase64(urL: string) {
    return this.httpWithoutInterceptor
      .get(urL, {
        observe: 'body',
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        map((arrayBuffer) =>
          btoa(
            Array.from(new Uint8Array(arrayBuffer))
              .map((b) => String.fromCharCode(b))
              .join(''),
          ),
        ),
      );
  }

  // Retry-load an image until it’s actually available
  waitForPublicImage(url: string, maxAttempts = 10, delayMs = 500): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let attempt = 0;

      const tryLoad = () => {
        attempt++;
        const tester = new Image();
        // NOTE: we add a cache-buster so a cached 404 doesn't stick
        const bust = (url.indexOf('?') >= 0 ? '&' : '?') + 'cb=' + Date.now();
        tester.onload = () => resolve();
        tester.onerror = () => {
          if (attempt >= maxAttempts) {
            reject(new Error('image not available'));
          } else {
            const backoff = Math.min(delayMs * Math.pow(2, attempt - 1), 5000);
            setTimeout(tryLoad, backoff);
          }
        };
        tester.src = url + bust;
      };

      tryLoad();
    });
  }
}
